import { motion } from 'framer-motion';
import { Star, TrendingUp, Clock, CheckCircle, XCircle, Filter } from 'lucide-react';

const statusConfig = {
  pending: { icon: Clock, color: 'text-yellow-600', bg: 'bg-yellow-100' },
  accepted: { icon: CheckCircle, color: 'text-green-600', bg: 'bg-green-100' },
  declined: { icon: XCircle, color: 'text-red-600', bg: 'bg-red-100' },
  filtered: { icon: Filter, color: 'text-gray-600', bg: 'bg-gray-100' },
};

export default function SubmissionCard({ submission, selected, onClick }) {
  const status = statusConfig[submission.status] || statusConfig.pending;
  const StatusIcon = status.icon;

  return (
    <motion.div
      whileHover={{ scale: 1.01 }}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      onClick={onClick}
      className={`p-4 rounded-xl border cursor-pointer transition-all ${
        selected
          ? 'border-purple-500 bg-purple-50'
          : 'border-gray-200 bg-white hover:border-purple-200'
      }`}
    >
      <div className="flex items-start justify-between mb-2">
        <div>
          <h4 className="font-medium text-gray-800">
            {submission.fan_name || 'Anonymous'}
          </h4>
          <p className="text-xs text-gray-500 mt-1 line-clamp-2">
            {submission.fan_summary || 'No summary available'}
          </p>
        </div>
        <div className={`px-2 py-1 rounded-full ${status.bg} flex items-center gap-1`}>
          <StatusIcon size={12} className={status.color} />
          <span className={`text-xs capitalize ${status.color}`}>
            {submission.status}
          </span>
        </div>
      </div>

      <div className="flex gap-4 mt-3">
        <div className="flex items-center gap-1">
          <Star size={14} className="text-yellow-500" />
          <span className="text-xs text-gray-600">
            Fit: {submission.fit_score?.toFixed(1) || 'N/A'}
          </span>
        </div>
        <div className="flex items-center gap-1">
          <TrendingUp size={14} className="text-purple-500" />
          <span className="text-xs text-gray-600">
            Priority: {submission.priority_score?.toFixed(1) || 'N/A'}
          </span>
        </div>
      </div>
    </motion.div>
  );
}
